import { render, staticRenderFns } from "./Writings.vue?vue&type=template&id=05d1a7d8&scoped=true"
import script from "./Writings.vue?vue&type=script&lang=js"
export * from "./Writings.vue?vue&type=script&lang=js"
import style0 from "./Writings.vue?vue&type=style&index=0&id=05d1a7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1a7d8",
  null
  
)

export default component.exports